import React, {ReactElement} from 'react';
import {connect} from 'react-redux';
import {useTranslation} from 'react-i18next';
import {Snackbar} from '@material-ui/core';
import MuiAlert from '@material-ui/lab/Alert';

import {_snackbarAcknowledgement} from '../../../../shared/src/store/actions/AuthActions';

function Alert(props: any) {
  const {t} = useTranslation();
  return <MuiAlert elevation={6} variant={t('COMMON.FILLED')} {...props} />;
}

const SnackBar = (props: any): ReactElement => {
  const {t} = useTranslation();
  const {snackBarEnabled, snackBarMessage, snackBarType} = props;

  const handleClose = (event: any, reason: any) => {
    if (reason === t('COMMON.CLICKAWAY')) {
      return;
    }
    props._snackbarAcknowledgement(
      false,
      t('COMMON.EMPTYSTRING'),
      t('COMMON.EMPTYSTRING')
    );
  };

  return (
    <div>
      <Snackbar
        open={snackBarEnabled}
        anchorOrigin={{
          vertical: t('COMMON.BOTTOM'),
          horizontal: t('COMMON.RIGHT'),
        }}
        autoHideDuration={5000}
        onClose={handleClose}>
        <Alert onClose={handleClose} severity={snackBarType}>
          {snackBarMessage}
        </Alert>
      </Snackbar>
    </div>
  );
};

// type state = {
//   auth: {
//     oauth?: string;
//   };
// };

function mapStateToProps(state: any) {
  return {
    snackBarEnabled: state.patientInfo.snackBarEnabled,
    snackBarMessage: state.patientInfo.snackBarMessage,
    snackBarType: state.patientInfo.snackBarType,
  };
}

export default connect(mapStateToProps, {_snackbarAcknowledgement})(SnackBar);
